import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

export const sendSupportRequest = createAsyncThunk(
  "supportRequest/send",
  async (data) => {
    const response = await api.post("/support-request", data);
    return response.data;
  }
);
